

// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { Badge, Spinner, Modal } from "react-bootstrap";
// import axios from "axios";
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData';

// const ProductsList = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [products, setProducts] = useState([]);
//     const [productImages, setProductImages] = useState([]);
//     const [combinedProducts, setCombinedProducts] = useState([]);
//     const [filteredProducts, setFilteredProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
    
//     // Modal States for product details
//     const [showProductModal, setShowProductModal] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [selectedImagePreview, setSelectedImagePreview] = useState('');
    
//     // Authentication states
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
    
//     // Cart state
//     const [cart, setCart] = useState(() => {
//         const savedCart = localStorage.getItem('cart');
//         return savedCart ? JSON.parse(savedCart) : [];
//     });
    
//     // Theme color
//     const THEME_COLOR = '#065f46';

//     // Get currency from DefaultData
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     useEffect(() => {
//         // Check if user is logged in
//         checkAuthStatus();
        
//         // Get search term from URL query parameters
//         const queryParams = new URLSearchParams(location.search);
//         const term = queryParams.get('q') || '';
//         setSearchTerm(term);
        
//         loadProductsAndImages(term);
        
//         // Load cart from localStorage or initialize
//         const savedCart = localStorage.getItem('cart');
//         if (savedCart) {
//             setCart(JSON.parse(savedCart));
//         }
//     }, [location.search]);

//     const checkAuthStatus = () => {
//         const token = localStorage.getItem('token');
//         const user = localStorage.getItem('user');
        
//         if (token && user) {
//             setIsLoggedIn(true);
//             setCurrentUser(JSON.parse(user));
//         } else {
//             setIsLoggedIn(false);
//             setCurrentUser(null);
//         }
//     };

//     const loadProductsAndImages = async (searchTerm) => {
//         try {
//             setLoading(true);
            
//             const [productsRes, imagesRes] = await Promise.all([
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
//             ]);
            
//             let allProducts = productsRes.data || [];
//             let allImages = imagesRes.data || [];
            
//             setProducts(allProducts);
//             setProductImages(allImages);
            
//             const combined = allProducts.map(product => {
//                 const imagesForProduct = allImages.filter(
//                     img => img.productId === product.prodcutId || img.productId === product.productId
//                 );
                
//                 const mainImage = imagesForProduct.length > 0 ? imagesForProduct[0].imageSrc : null;
//                 const allProductImages = imagesForProduct.map(img => ({
//                     id: img.productImageId,
//                     name: img.imageName,
//                     src: img.imageSrc
//                 }));
                
//                 return {
//                     ...product,
//                     id: product.prodcutId || product.productId,
//                     mainImage,
//                     allImages: allProductImages,
//                     imageCount: imagesForProduct.length
//                 };
//             });
            
//             setCombinedProducts(combined);
            
//             if (searchTerm.trim()) {
//                 const results = combined.filter(product =>
//                     product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                     product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                     product.slug?.toLowerCase().includes(searchTerm.toLowerCase())
//                 );
//                 setFilteredProducts(results);
//             } else {
//                 setFilteredProducts(combined);
//             }
//         } catch (error) {
//             console.error("Error fetching data", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleNewSearch = (e) => {
//         e.preventDefault();
//         const newSearchTerm = e.target.search.value.trim();
//         if (newSearchTerm) {
//             navigate(`/products/search?q=${encodeURIComponent(newSearchTerm)}`);
//         } else {
//             navigate('/products');
//         }
//     };

//     const handleClearSearch = () => {
//         setSearchTerm('');
//         navigate('/products');
//     };

//     const handleProductClick = (product) => {
//         setSelectedProduct(product);
//         setSelectedImagePreview(product.mainImage || '');
//         setShowProductModal(true);
//     };

//     const addToCart = (product, quantity = 1) => {
//         const existingItemIndex = cart.findIndex(item => item.id === product.id);
//         let updatedCart = [...cart];
        
//         if (existingItemIndex > -1) {
//             updatedCart[existingItemIndex].quantity += quantity;
//         } else {
//             updatedCart.push({
//                 id: product.id,
//                 name: product.productName,
//                 price: product.sellingPrice,
//                 image: product.mainImage,
//                 quantity: quantity,
//                 availableQuantity: product.quantityAvailable
//             });
//         }
        
//         setCart(updatedCart);
//         localStorage.setItem('cart', JSON.stringify(updatedCart));
//         alert(`${product.productName} added to cart!`);
//     };

//     const viewCart = () => {
//         navigate('/cart');
//     };

//     const formatCurrency = (amount) => {
//         return `${currency} ${amount?.toFixed(2) || '0.00'}`;
//     };

//     return (
//         <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '100px' }}>
//             <div className="container py-4">
//                 {/* Search Bar */}
//                 <div className="row mb-4">
//                     <div className="col-12">
//                         <div className="card border-0 shadow-sm p-3 mb-4" style={{ borderRadius: '1rem' }}>
//                             <form onSubmit={handleNewSearch}>
//                                 <div className="input-group">
//                                     <span className="input-group-text bg-transparent border-0">
//                                         <i className="ri-search-line fs-5" style={{ color: THEME_COLOR }}></i>
//                                     </span>
//                                     <input
//                                         type="text"
//                                         name="search"
//                                         className="form-control border-0 shadow-none fw-medium py-3"
//                                         placeholder="Search products by name, description..."
//                                         defaultValue={searchTerm}
//                                         autoComplete="off"
//                                     />
//                                     <button 
//                                         type="submit"
//                                         className="btn text-white px-4"
//                                         style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}
//                                     >
//                                         Search
//                                     </button>
//                                     {searchTerm && (
//                                         <button 
//                                             type="button"
//                                             className="btn btn-outline-secondary ms-2 px-4"
//                                             onClick={handleClearSearch}
//                                             style={{ borderRadius: '0.75rem' }}
//                                         >
//                                             Clear
//                                         </button>
//                                     )}
//                                     <button 
//                                         type="button"
//                                         className="btn ms-2 position-relative"
//                                         style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '0.75rem' }}
//                                         onClick={viewCart}
//                                     >
//                                         <i className="ri-shopping-cart-line"></i>
//                                         {cart.length > 0 && (
//                                             <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
//                                                 {cart.reduce((total, item) => total + item.quantity, 0)}
//                                             </span>
//                                         )}
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Results Header */}
//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                     <div>
//                         <h2 className="h3 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>
//                             {searchTerm ? `Results for "${searchTerm}"` : 'All Products'}
//                         </h2>
//                     </div>
//                     <div className="d-flex align-items-center">
//                         <Badge bg="light" text="dark" className="px-3 py-2 me-3">
//                             {filteredProducts.length} product{filteredProducts.length !== 1 ? 's' : ''} found
//                         </Badge>
//                         <button 
//                             className="btn btn-sm position-relative"
//                             style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '0.5rem' }}
//                             onClick={viewCart}
//                         >
//                             <i className="ri-shopping-cart-line me-1"></i>
//                             Cart
//                             {cart.length > 0 && (
//                                 <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
//                                     {cart.reduce((total, item) => total + item.quantity, 0)}
//                                 </span>
//                             )}
//                         </button>
//                     </div>
//                 </div>

//                 {loading ? (
//                     <div className="text-center py-5">
//                         <Spinner animation="border" style={{ color: THEME_COLOR }} />
//                         <p className="text-muted mt-3">Loading products...</p>
//                     </div>
//                 ) : (
//                     <div className="row g-4">
//                         {filteredProducts.map(product => (
//                             <div className="col-12 col-md-6 col-lg-4" key={product.id}>
//                                 <div className="card border-0 shadow-sm h-100" 
//                                      style={{ borderRadius: '1.5rem', cursor: 'pointer' }}
//                                      onClick={() => handleProductClick(product)}
//                                 >
//                                     <div style={{ height: '200px', backgroundColor: '#f0fdf4', borderTopLeftRadius: '1.5rem', borderTopRightRadius: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
//                                         {product.mainImage ? (
//                                             <img src={product.mainImage} alt={product.productName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                                         ) : (
//                                             <i className="ri-shopping-bag-line fs-1" style={{ color: THEME_COLOR }}></i>
//                                         )}
//                                     </div>
                                    
//                                     <div className="card-body p-4">
//                                         <div className="d-flex justify-content-between align-items-start mb-2">
//                                             <h5 className="fw-bold mb-1 text-dark flex-grow-1">{product.productName}</h5>
//                                             <Badge bg={product.quantityAvailable > 0 ? "success" : "danger"}>
//                                                 {product.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}
//                                             </Badge>
//                                         </div>
//                                         <h4 className="fw-bold mb-3" style={{ color: THEME_COLOR }}>{formatCurrency(product.sellingPrice)}</h4>
                                        
//                                         <div className="mt-4 pt-3 border-top d-flex gap-2">
//                                             <button 
//                                                 className="btn btn-sm flex-grow-1"
//                                                 style={{ backgroundColor: '#f8f9fa', border: '1px solid #d1d5db', borderRadius: '6px' }}
//                                                 onClick={(e) => { e.stopPropagation(); navigate(`/product-details/${product.id}`); }}
//                                             >
//                                                 View Details
//                                             </button>
//                                             <button 
//                                                 className="btn btn-sm flex-grow-1"
//                                                 style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '6px' }}
//                                                 onClick={(e) => { e.stopPropagation(); addToCart(product); }}
//                                                 disabled={product.quantityAvailable <= 0}
//                                             >
//                                                 Add to Cart
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 )}
//             </div>

//             {/* ================= PRODUCT DETAILS MODAL ================= */}
//             <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered>
//                 <Modal.Header closeButton className="border-0 pb-0">
//                     <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>Product Details</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body className="p-4">
//                     {selectedProduct && (
//                         <div className="row g-4">
//                             <div className="col-md-6">
//                                 <div className="mb-3 rounded-4 overflow-hidden shadow-sm border">
//                                     <img src={selectedImagePreview} alt="Main" className="w-100" style={{ height: '350px', objectFit: 'cover' }} />
//                                 </div>
//                                 <div className="row g-2">
//                                     {selectedProduct.allImages?.map((img, idx) => (
//                                         <div className="col-3" key={idx}>
//                                             <img src={img.src} alt="thumb" className="w-100 rounded border" style={{ height: '60px', objectFit: 'cover', cursor: 'pointer' }} onClick={() => setSelectedImagePreview(img.src)} />
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>

//                             <div className="col-md-6 d-flex flex-column">
//                                 <h3 className="fw-bold text-dark">{selectedProduct.productName}</h3>
//                                 <h2 className="fw-bold my-3" style={{ color: THEME_COLOR }}>{formatCurrency(selectedProduct.sellingPrice)}</h2>
//                                 <p className="text-secondary mb-4">{selectedProduct.description || "No description available."}</p>
                                
//                                 <div className="d-grid gap-2 mt-auto">
//                                     <button 
//                                         className="btn py-3 rounded-pill text-white fw-bold"
//                                         style={{ backgroundColor: THEME_COLOR }}
//                                         onClick={() => addToCart(selectedProduct)}
//                                         disabled={selectedProduct.quantityAvailable <= 0}
//                                     >
//                                         Add to Cart <i className="ri-shopping-cart-line ms-2"></i>
//                                     </button>
//                                     <button 
//                                         className="btn py-3 rounded-pill fw-bold"
//                                         style={{ backgroundColor: 'white', color: THEME_COLOR, border: `2px solid ${THEME_COLOR}` }}
//                                         onClick={() => navigate(`/product-details/${selectedProduct.id}`)}
//                                     >
//                                         Full Details
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </Modal.Body>
//             </Modal>
//         </div>
//     );
// };

// export default ProductsList;
// web view 


import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, Spinner, Modal } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const ProductsList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [productImages, setProductImages] = useState([]);
    const [combinedProducts, setCombinedProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [showProductModal, setShowProductModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImagePreview, setSelectedImagePreview] = useState('');
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    
    const [cart, setCart] = useState(() => {
        const savedCart = localStorage.getItem('cart');
        return savedCart ? JSON.parse(savedCart) : [];
    });
    
    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        checkAuthStatus();
        const queryParams = new URLSearchParams(location.search);
        const term = queryParams.get('q') || '';
        setSearchTerm(term);
        loadProductsAndImages(term);
        const savedCart = localStorage.getItem('cart');
        if (savedCart) { setCart(JSON.parse(savedCart)); }
    }, [location.search]);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) { setIsLoggedIn(true); setCurrentUser(JSON.parse(user)); }
    };

    const loadProductsAndImages = async (searchTerm) => {
        try {
            setLoading(true);
            const [productsRes, imagesRes] = await Promise.all([
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
            ]);
            let allProducts = productsRes.data || [];
            let allImages = imagesRes.data || [];
            setProducts(allProducts);
            setProductImages(allImages);
            const combined = allProducts.map(product => {
                const imagesForProduct = allImages.filter(img => img.productId === product.prodcutId || img.productId === product.productId);
                const mainImage = imagesForProduct.length > 0 ? imagesForProduct[0].imageSrc : null;
                const allProductImages = imagesForProduct.map(img => ({ id: img.productImageId, name: img.imageName, src: img.imageSrc }));
                return { ...product, id: product.prodcutId || product.productId, mainImage, allImages: allProductImages, imageCount: imagesForProduct.length };
            });
            setCombinedProducts(combined);
            if (searchTerm.trim()) {
                const results = combined.filter(product =>
                    product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    product.slug?.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setFilteredProducts(results);
            } else { setFilteredProducts(combined); }
        } catch (error) { console.error("Error fetching data", error); } finally { setLoading(false); }
    };

    const handleNewSearch = (e) => {
        e.preventDefault();
        const newSearchTerm = e.target.search.value.trim();
        if (newSearchTerm) { navigate(`/products/search?q=${encodeURIComponent(newSearchTerm)}`); } else { navigate('/products'); }
    };

    const handleClearSearch = () => { setSearchTerm(''); navigate('/products'); };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setSelectedImagePreview(product.mainImage || '');
        setShowProductModal(true);
    };

    const addToCart = (product, quantity = 1) => {
        const existingItemIndex = cart.findIndex(item => item.id === product.id);
        let updatedCart = [...cart];
        if (existingItemIndex > -1) { updatedCart[existingItemIndex].quantity += quantity; } else {
            updatedCart.push({ id: product.id, name: product.productName, price: product.sellingPrice, image: product.mainImage, quantity: quantity, availableQuantity: product.quantityAvailable });
        }
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        alert(`${product.productName} added to cart!`);
    };

    const viewCart = () => { navigate('/cart'); };
    const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

    return (
        /* INCREASED PADDING TOP HERE (pt-lg-5 pt-5 mt-4) TO STOP THE MERGING ISSUE */
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh' }} className="pt-lg-5 pt-5 mt-lg-5 mt-4">
            <div className="container py-2">
                
                {/* BACK BUTTON AND SEARCH AREA - FIXED OVERLAP */}
                <div className="row mb-3 mt-2 mt-lg-0">
                    <div className="col-12 d-flex align-items-center">
                        <button onClick={() => navigate(-1)} className="btn border-0 p-0 me-2 shadow-none"><i className="ri-arrow-left-line fs-2"></i></button>
                        <div className="card border-0 shadow-sm p-2 flex-grow-1" style={{ borderRadius: '1rem' }}>
                            <form onSubmit={handleNewSearch}>
                                <div className="input-group">
                                    <input type="text" name="search" className="form-control border-0 shadow-none py-1" placeholder="Search..." defaultValue={searchTerm} />
                                    <button type="submit" className="btn text-white px-3" style={{ backgroundColor: THEME_COLOR, borderRadius: '0.75rem' }}><i className="ri-search-line"></i></button>
                                    <button type="button" className="btn ms-2 position-relative" style={{ backgroundColor: THEME_COLOR, color: 'white', borderRadius: '0.75rem' }} onClick={viewCart}>
                                        <i className="ri-shopping-cart-line"></i>
                                        {cart.length > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize: '0.65rem'}}>{cart.reduce((t, i) => t + i.quantity, 0)}</span>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="h5 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>All Products</h2>
                    <Badge bg="light" text="dark" className="px-3 py-2 border small">{filteredProducts.length} found</Badge>
                </div>

                {loading ? <div className="text-center py-5"><Spinner animation="border" style={{ color: THEME_COLOR }} /></div> : (
                    <div className="row g-2 g-lg-4">
                        {filteredProducts.map(product => (
                            <div className="col-6 col-md-4 col-lg-3" key={product.id}>
                                <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '1.2rem' }} onClick={() => handleProductClick(product)}>
                                    <div style={{ height: '160px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', borderTopLeftRadius:'1.2rem', borderTopRightRadius:'1.2rem' }}>
                                        <img src={product.mainImage || 'https://placehold.co/150'} alt={product.productName} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                    </div>
                                    <div className="card-body p-2 p-lg-3">
                                        <h6 className="fw-bold mb-1 text-dark text-truncate small">{product.productName}</h6>
                                        <h5 className="fw-bold mb-2" style={{ color: THEME_COLOR, fontSize: '0.9rem' }}>{formatCurrency(product.sellingPrice)}</h5>
                                        <button className="btn btn-sm w-100 text-white" style={{ backgroundColor: THEME_COLOR, borderRadius: '6px', fontSize: '0.75rem' }} onClick={(e) => { e.stopPropagation(); addToCart(product); }} disabled={product.quantityAvailable <= 0}>Add to Cart</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* PRODUCT MODAL - REMAINS ORIGINAL */}
            <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered>
                <Modal.Body className="p-4 text-start">
                    {selectedProduct && (
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="bg-light rounded-4 overflow-hidden border text-center">
                                    <img src={selectedImagePreview} alt="Main" style={{ height: '300px', maxWidth: '100%', objectFit: 'contain' }} />
                                </div>
                            </div>
                            <div className="col-md-6 d-flex flex-column">
                                <h3 className="fw-bold">{selectedProduct.productName}</h3>
                                <h2 className="fw-bold my-3" style={{ color: THEME_COLOR }}>{formatCurrency(selectedProduct.sellingPrice)}</h2>
                                <p className="text-secondary small">{selectedProduct.description}</p>
                                <div className="mt-auto d-grid gap-2">
                                    <button className="btn py-3 rounded-pill text-white fw-bold" style={{ backgroundColor: THEME_COLOR }} onClick={() => addToCart(selectedProduct)} disabled={selectedProduct.quantityAvailable <= 0}>Add to Cart</button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ProductsList;